var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopYIconSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 32,
    viewBox: "0 0 26 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 10V28H8.125V10H22.75ZM22.75 8H8.125C7.69402 8 7.2807 8.21071 6.97595 8.58579C6.67121 8.96086 6.5 9.46957 6.5 10V28C6.5 28.5304 6.67121 29.0391 6.97595 29.4142C7.2807 29.7893 7.69402 30 8.125 30H22.75C23.181 30 23.5943 29.7893 23.899 29.4142C24.2038 29.0391 24.375 28.5304 24.375 28V10C24.375 9.46957 24.2038 8.96086 23.899 8.58579C23.5943 8.21071 23.181 8 22.75 8Z",
    fill: "#1F7E78"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 18H1.625V4C1.625 3.46957 1.7962 2.96086 2.10095 2.58579C2.4057 2.21071 2.81902 2 3.25 2H14.625V4H3.25V18Z",
    fill: "#1F7E78"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopYIconSvg);
export default __webpack_public_path__ + "static/media/CopYIconSvg.04de747b9e72ca2eff4c51f0faa9bc55.svg";
export { ForwardRef as ReactComponent };